import { getCookie, removeCookie, setCookie } from './utils';
var Cookies = /** @class */ (function () {
    function Cookies() {
    }
    Cookies.prototype.setTokens = function (_a) {
        var idToken = _a.idToken, token = _a.token;
        !!token && setCookie('kcToken', btoa(token));
        !!idToken && setCookie('kcIdToken', btoa(idToken));
    };
    Cookies.prototype.getTokens = function () {
        var tknStr = getCookie('kcToken');
        var idTknStr = getCookie('kcIdToken');
        return {
            idToken: idTknStr ? atob(idTknStr) : undefined,
            refreshToken: '',
            token: tknStr ? atob(tknStr) : undefined,
        };
    };
    Cookies.prototype.resetTokens = function () {
        removeCookie('kcToken');
        removeCookie('kcIdToken');
    };
    return Cookies;
}());
export { Cookies };
//# sourceMappingURL=client.js.map